import { useTranslations } from "next-intl"
import * as yup from "yup"
import {
  createAgreeTermsValidation,
  createEmailValidation,
  createIdNumberValidation,
  createLicensePlateValidation,
  createPhoneNumberValidation,
} from "./formValidationUtils"

/**
 * Creates form validation schema for the Policy Form
 * Uses translation keys for error messages and leverages shared validation utilities
 */
export const usePolicyFormValidationSchema = () => {
  const t = useTranslations("PolicyForm.validation")

  return yup.object().shape({
    policyNumber: yup.string().required(t("required")),
    email: createEmailValidation(t("required"), t("invalidEmail")),
    licensePlate: createLicensePlateValidation(t("required")),
    phoneNumber: createPhoneNumberValidation(
      t("required"),
      t("phoneNumberDigitsOnly"),
    ),
    id: createIdNumberValidation(t("required"), t("idNumberDigitsOnly")),
    agreeTerms: createAgreeTermsValidation(t("agreeTermsRequired")),
  })
}
